import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Temporary console filter — silence WebGL/Three.js noise while debugging voice pipeline.
{
  const NOISE = /webgl|three\.|gl_invalid|program info log|shader|texture has been resized/i;
  for (const lvl of ['error', 'warn', 'log']) {
    const orig = console[lvl].bind(console);
    console[lvl] = (...args) => {
      const first = args[0];
      if (typeof first === 'string' && NOISE.test(first)) return;
      orig(...args);
    };
  }
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
